// config
var APP = {
	bp: {
		mobile: 959
	}
};
